
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shortName]/lock-met",
      function () {
        return require("private-next-pages/[shortName]/lock-met/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shortName]/lock-met"])
      });
    }
  